import React from 'react';
import { useParams } from 'react-router';
import { getNewUserLineupLink } from 'src/utils/getLinks';
import { useErrorBoundary } from 'use-error-boundary';

function RedirectToLineupPage() {
  let { rest_id, menu_id } = useParams();
  localStorage.clear();
  window.location.href = getNewUserLineupLink(rest_id, menu_id);
  return <></>;
}

export default ({ children }) => {
  const { ErrorBoundary, didCatch, error, reset } = useErrorBoundary();

  // consider:
  // redirect user to restart when error found.
  if (didCatch) {
    if (process.env.NODE_ENV === 'production') {
      return <RedirectToLineupPage />;
    }
  }

  return (
    <>
      <ErrorBoundary>{children}</ErrorBoundary>
    </>
  );
};
